import { Component, OnInit, Input, ElementRef, OnChanges, SimpleChanges, HostListener } from '@angular/core';

function getLastSunday(date?: Date) {
  if (!date) {
    date = new Date();
  }
  const today = date.getDate();
  const dayOfTheWeek = date.getDay() || 7;
  const newDate = date.setDate(today - dayOfTheWeek);
  return new Date(newDate);
}

function getUpcomingSunday(date?: Date) {
  if (!date) {
    date = new Date();
  }
  const today = date.getDate();
  const dayOfTheWeek = date.getDay();
  const newDate = date.setDate(today - dayOfTheWeek + 7);
  return new Date(newDate);
}

@Component({
  selector: 'app-dashboard-event-graph',
  templateUrl: './dashboard-event-graph.component.html',
  styleUrls: ['./dashboard-event-graph.component.scss']
})
export class DashboardEventGraphComponent implements OnInit, OnChanges {

  // @ViewChild('graph', {}) graphdiv: ElementRef;

  @Input() data: {date: Date, successful: number, progress: number, error: number}[] = [];
  @Input() type: 'daily' | 'monthly' = 'monthly';
  @Input() height = 300;
  @Input() barWidth = 20;

  @Input() colors = ['#29B5E8', '#F3D758', '#CB5A48'];

  public barGroupData: {bars: {width: number, color: string, height: number, tooltip: number, value: number}[], label: string}[] = [];
  private highestValue: number;

  constructor(private elRef: ElementRef) { }

  ngOnInit() {
    if (this.barGroupData.length > 0) {
      this.updateChart(this.data);
    }
  }

  updateChart(data: {date: Date, successful: number, progress: number, error: number}[]) {
    const groups = new Map<string, {
      successful: number,
      progress: number,
      error: number
    }>();

    if (this.type === 'daily') {
      data.map(event => {
        const date = event.date.toISOString().substring(0, 10).replace(/\-/g, '/');

        if (!groups.has(date)) {
          groups.set(date, {
            successful: 0,
            progress: 0,
            error: 0
          });
        }

        const obj = groups.get(date);

        ['successful', 'progress', 'error'].forEach(variant => obj[variant] += event[variant]);

        groups.set(date, obj);
      });
    } else if (this.type === 'monthly') {
      data.map(event => {
        const date = event.date.toISOString().substring(0, 7).replace(/\-/g, '/');

        if (!groups.has(date)) {
          groups.set(date, {
            successful: 0,
            progress: 0,
            error: 0
          });
        }

        const obj = groups.get(date);

        ['successful', 'progress', 'error'].forEach(variant => obj[variant] += event[variant]);

        groups.set(date, obj);
      });
    } else {
      console.warn('Unknown type: ', this.type);
    }

    const barGroup = [];
    for (const date of groups.keys()) {
      const bars = [];
      const obj = groups.get(date);
      [obj.successful, obj.progress, obj.error].forEach((value, i) => {
        if (value) {
          bars.push({
            color: this.colors[i],
            tooltip: value + ' ' + ['sent', 'in progress', 'errors'][i],
            value
          });
        }
      });
      barGroup.push({
        highest: bars.reduce((prev, curr) => Math.max(prev, curr.value || 0), 0) || 1,
        width: this.barWidth,
        label: date,
        bars
      });
    }
    this.highestValue = barGroup.reduce((prev, curr) => Math.max(prev, curr.highest || 0), 0) || 1;

    for (const group of barGroup) {
      for (const bar of group.bars) {
        bar.height = (this.height - 31 - 46 - 30 - 10) * (bar.value / this.highestValue);
      }
    }

    const sorted = barGroup.sort((prev, curr) => prev.label === curr.label ? 0 : (curr.label < prev.label ? 1 : -1));
    sorted.forEach(group => {
      group.label = (new Date(group.label)).toLocaleDateString();
      if (this.type === "monthly") {
        group.label = group.label.substring(3);
      }
    });
    this.barGroupData = sorted;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data) {
      if (!changes.data.currentValue || !(changes.data.currentValue instanceof Array)) {
        console.warn('Invalid data type:', changes.data.currentValue);
        return;
      }
      this.updateChart(changes.data.currentValue);
    } else if (changes.colors) {
      if (!changes.colors.currentValue || !(changes.colors.currentValue instanceof Array) || changes.colors.currentValue.length !== 3) {
        console.warn('Invalid colors:', changes.colors.currentValue);
        return;
      }
      this.updateChart(this.data);
    } else if (changes.height) {
      this.updateChart(this.data);
    } else if (changes.type) {
      this.updateChart(this.data);
    }
  }

}
